export const WORKFLOW_STEPS = [
  { id: 'load', label: 'Data', helpText: 'Bring in & review' },
  { id: 'map', label: 'Map', helpText: 'Chart & fields' },
  { id: 'style', label: 'Style', helpText: 'Appearance' },
  { id: 'export', label: 'Export', helpText: 'Download' },
]

export const MAP_TABS = [
  { id: 'chart', label: 'Chart' },
  { id: 'mapping', label: 'Mapping' },
  { id: 'assist', label: 'Assistant' },
]

export const STYLE_TABS = [
  { id: 'brand', label: 'Appearance' },
  { id: 'labels', label: 'Text' },
  { id: 'layout', label: 'Layout' },
]

export const SESSION_SAVE_DEBOUNCE_MS = 1200
